// extracted by mini-css-extract-plugin
export default {"avatar":"Gh41yOh","avatar--clickable":"Bxpg9n4"};